import React from 'react';

const LukIkon = () => (
	<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
		<rect x="14.8496" y="0.00158691" width="1" height="21" transform="rotate(45 14.8496 0.00158691)" fill="#CE0060" />
		<rect x="15.5566" y="14.8492" width="1" height="21" transform="rotate(135 15.5566 14.8492)" fill="#CE0060" />
	</svg>
);

export default LukIkon;
